




































import { Component, Mixins } from 'vue-property-decorator';
import { Restaurant } from '@/api/model';
import MessageToastMixin from '@/mixins/MessageToastMixin';

@Component
export default class RestaurantNameForm extends Mixins(MessageToastMixin) {
  restaurant: Restaurant = {
    restaurantName: '',
  };

  saving = false;

  async submit() {
    this.saving = true;
    try {
      await this.$store.dispatch('restaurant/saveRestaurant', this.restaurant);
      this.saving = false;
    } catch (e) {
      this.saving = false;
      this.showError(this.$t('general.messages.error'));
    }
  }
}
